<template>
  <div class="p-2 items-center border border-solid border-gray-a10 flex gap-1 justify-between mb-3 rounded"
       @click="$emit('select-resolution')"
  >
    <div class="flex">
      <chart-legend :type="resolution.legendType" :show-label="false" class="mb-1"/>
      <vx-tooltip :text="resolution.name" position="bottom" class="ml-1 clamp break-all">
        {{ resolution.name }}
      </vx-tooltip>
    </div>

    <div class="flex">
      <span class="font-semibold">
        {{ getCategoryShare(resolution.data) }}
      </span>
      <span class="ml-1">
        ({{ getCategoryCount(resolution.data) }})
      </span>
    </div>
  </div>
</template>

<script>
import ChartLegend from '@/components/analytics/charts/ChartLegend'

export default {
  name: 'ResolutionFilterItem',

  components: {
    ChartLegend
  },

  props: {
    resolution: {
      type: Object,
      default: () => {}
    },
    categoryIndex: {
      type: Number,
      default: 0
    },
    totalRequests: {
      type: Number,
      default: 0
    }
  },

  methods: {
    getCategoryCount(categoryData) {
      return categoryData[this.categoryIndex][1]
    },

    getCategoryShare(categoryData) {
      if (!this.totalRequests) return '0%'

      const categoryCount = this.getCategoryCount(categoryData)
      return `${Math.round(categoryCount / this.totalRequests * 100)}%`
    }
  }
}
</script>
